import { render, staticRenderFns } from "./StartupCallList.vue?vue&type=template&id=15bdc03b&scoped=true"
import script from "./StartupCallList.vue?vue&type=script&lang=js"
export * from "./StartupCallList.vue?vue&type=script&lang=js"
import style0 from "./StartupCallList.vue?vue&type=style&index=0&id=15bdc03b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bdc03b",
  null
  
)

export default component.exports